import React from 'react';

/**
 * props:
 * - label
 * - htmlFor
 * - hint
 * - children
 * - className
 */
export function PageField({ label, htmlFor, hint, children, className = '' }) {
    return (
        <div className={`private-page-field ${className}`.trim()}>
            {label ? <label htmlFor={htmlFor} className="private-page-label">{label}</label> : null}
            {children}
            {hint ? <p className="private-page-field-hint">{hint}</p> : null}
        </div>
    );
}

export default PageField;